//虚拟接口数据
export default {
    //登录
    '/ucenter/account-entity/login': {
        "code": 0,
        "data": {},
        "message": "",
        "status": true
    },
    //登出
    "/ucenter/account-entity/loginOut": {
        "code": 0,
        "data": {},
        "message": "",
        "status": true
    },
    //修改密码
    "/ucenter/account-entity/updatePassWord": {
        "code": 0,
        "data": {},
        "message": "",
        "status": true
    }
}